import {
  AdminGetExamCenterMembersByExamCenterCodeDocument,
  GetExamCenterMembersByExamCenterCodeDocument,
  useDeleteManagerFromExamCenterMutation,
} from '@exam-center/graphql';
import { Text, ConfirmationModal } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

interface ExamCenterMemberDeletionModalProps {
  examCenterMemberId: string;
  open: boolean;
  onClose: () => void;
}

export default function ExamCenterMemberDeletionModal(
  props: Readonly<ExamCenterMemberDeletionModalProps>,
) {
  const { examCenterMemberId, open: isOpen, onClose } = props;

  const [deleteManagerFromExamCenter, { loading: isDeleting }] =
    useDeleteManagerFromExamCenterMutation();
  const { showSnackbar } = useSnackbar();

  const handleDelete = async () => {
    await deleteManagerFromExamCenter({
      variables: {
        deleteManagerFromExamCenterInput: {
          examCenterManagerId: examCenterMemberId,
        },
      },
      onCompleted: () => {
        showSnackbar({ message: 'ลบสมาชิกเรียบร้อยแล้ว', variant: 'success' });
        onClose();
      },
      onError: () => {
        showSnackbar({ message: 'เกิดข้อผิดพลาดในการลบสมาชิก', variant: 'error' });
        onClose();
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        AdminGetExamCenterMembersByExamCenterCodeDocument,
        GetExamCenterMembersByExamCenterCodeDocument,
      ],
    });
  };

  return (
    <ConfirmationModal
      open={isOpen}
      title='ยืนยันการลบสมาชิก?'
      content={
        <Text>
          คุณกำลังจะลบสมาชิกนี้ออกจากศูนย์ทดสอบ หลังจากลบแล้ว
          <br />
          ผู้ใช้นี้จะไม่สามารถเข้าใช้งานระบบ Exam Center ได้อีกต่อไป
        </Text>
      }
      acceptText='ลบสมาชิก'
      variant='error'
      onAccept={handleDelete}
      onDiscard={onClose}
      onClose={onClose}
      loading={isDeleting}
    />
  );
}
